export const GET_DEPARTMENTS = 'GET_DEPARTMENTS';

// departmentsテーブルのidに依存しているため、診療科マスタが変更された場合は反映が必要
export const DEPARTMENT_ID_DENTAL_SURGERY = 20;
export const EXCLUDE_DEPARTMENT_IDS = [DEPARTMENT_ID_DENTAL_SURGERY];
export const DEPARTMENT_ID_OTHER_DOCTOR = 27;
export const DEPARTMENT_ID_OTHER_DOCTOR_STRING = '27';
